/**
 * JourneyTag Component
 * A lightweight inline tag for displaying a new hire journey reference
 */

import { HStack, Icon, Text } from "@chakra-ui/react";
import { LuCompass } from "react-icons/lu";

export type JourneyTagSize = "sm" | "md";

export interface JourneyTagProps {
  name: string;
  size?: JourneyTagSize;
  onClick?: () => void;
  bordered?: boolean;
}

function JourneyTagComponent({ name, size = "md", onClick, bordered = false }: JourneyTagProps) {
  return (
    <HStack
      spacing={1}
      cursor={onClick ? "pointer" : "default"}
      onClick={onClick}
      _hover={onClick ? { color: "brand.500" } : undefined}
      transition="color 0.15s"
      {...(bordered
        ? {
            borderWidth: "1px",
            borderColor: "gray.200",
            borderRadius: "full",
            px: size === "sm" ? 2 : 2.5,
            py: size === "sm" ? 0.5 : 1,
          }
        : {})}
    >
      <Icon as={LuCompass} boxSize={size === "sm" ? 3 : 3.5} color="gray.400" flexShrink={0} />
      <Text fontSize={size === "sm" ? "xs" : "sm"} color="gray.600" fontWeight="normal" noOfLines={1}>
        {name}
      </Text>
    </HStack>
  );
}

export const JourneyTag = JourneyTagComponent;
